import React from 'react';
import Card from 'react-bootstrap/Card';
import moment from 'moment';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import Badge from 'react-bootstrap/Badge';
import { useTranslation } from 'react-i18next';
import { shortenStringWithTooltip, shortenString } from '../../helper';

function BomTypeGroupCard({
  item,
  index,
  onCheck,
  onEdit,
  onDelete,
  selectedIds,
  AddEditDesignWrapper,
  DeleteDesignWrapper,
  inputCheck,
  BomAddEditAccess,
  BomDeleteAccess,
}) {
  const { t } = useTranslation('common');

  const onlyShow = 3;
  const isChecked = selectedIds.filter((val) => val === item._id).length > 0;
  return (
    <div id="accordion" className="col-lg-3">
      <Card className="listing-card">
        <Card.Header>
          <ul className="card-header-icon">
            {BomAddEditAccess || BomDeleteAccess ? (
              <li>
                <div className="cus-chk-block">
                  <input
                    onChange={(e) => {
                      onCheck(e, item._id, index);
                    }}
                    name={`check_${index}`}
                    id={`check_${index}`}
                    type="checkbox"
                    checked={isChecked}
                    disabled={inputCheck}
                  />
                  <label htmlFor={`check_${index}`} className="cus-chklabel" />
                </div>
              </li>
            ) : (
              ''
            )}
            <AddEditDesignWrapper>
              <li>
                <a
                  href={() => false}
                  onClick={() => {
                    onEdit(item._id);
                  }}
                  title={t('BOM_TYPE_GROUP_CARD.EDIT_TITLE')}
                >
                  <i className="icon-edit" />
                </a>
              </li>
            </AddEditDesignWrapper>
            <DeleteDesignWrapper>
              <li>
                <a
                  href={() => false}
                  onClick={() => {
                    onDelete(item._id);
                  }}
                  title={t('BOM_TYPE_GROUP_CARD.DELETE_TITLE')}
                >
                  <i className="icon-delete" />
                </a>
              </li>
            </DeleteDesignWrapper>
          </ul>
        </Card.Header>
        <Card.Body>
          <h4 className="title" title={item?.name || ''}>
            {item?.name ? shortenString(item?.name, 20) : ''}
          </h4>
          <ul className="card-ul">
            <li className="m-h-2">
              <strong>{t('BOM_TYPE_GROUP_CARD.PRODUCT_TYPE')}: </strong>
              {item?.productType?.name}
            </li>
            <li>
              <strong>{t('BOM_TYPE_GROUP_CARD.BOM_TYPE')}:</strong>

              <div className="d-flex align-items-center mt-1">
                {item?.bomTypes?.map(
                  (product, i) =>
                    i < onlyShow && (
                      <Badge key={i} pill className="bg-secondary text-light mr-1 cursor-pointer  text-decoration-nonepy-1">
                        {product.name.length > 15 ? (
                          <p className="text-truncate m-0 badge-mw-55" title={product.name}>
                            {product.name}
                          </p>
                        ) : (
                          <p className="badge-mw-55 m-0">{product.name}</p>
                        )}
                      </Badge>
                    ),
                )}

                {item?.bomTypes?.length > onlyShow && (
                  <OverlayTrigger
                    placement="bottom"
                    overlay={
                      <Tooltip className="text-tooltip" id="badge-tooltip">
                        <div style={{ Width: 'auto' }}>
                          {item.bomTypes
                            .slice(onlyShow)
                            .map((product, i) => `${product.name}`)
                            .join(', ')}
                        </div>
                      </Tooltip>
                    }
                  >
                    <Badge pill className="bg-success text-light mr-1 py-1 cursor-pointer text-decoration-none">
                      {`+ ${item.bomTypes.length - onlyShow}`}
                    </Badge>
                  </OverlayTrigger>
                )}
              </div>
            </li>
            <li className="m-h-2">
              <strong>{t('BOM_TYPE_GROUP_CARD.ADDITIONAL_INFO')}: </strong>
              {item?.additionalInfo ? shortenStringWithTooltip(item.additionalInfo, 110) : ''}
            </li>
            <li>
              <strong>{t('BOM_TYPE_GROUP_CARD.CREATED')}: </strong>
              {shortenStringWithTooltip(item.createdBy, 6)} | {moment(item.createdAt).format('DD-MMM-YYYY ')}|{' '}
              <span> {moment(item.createdAt).format('hh:mm A')} </span>
            </li>
            <li>
              <strong>{t('BOM_TYPE_GROUP_CARD.MODIFIED')}: </strong>
              {shortenStringWithTooltip(item.modifiedBy, 6) || shortenStringWithTooltip(item.createdBy, 6)} |{' '}
              {moment(item.updatedAt || item.createdAt).format('DD-MMM-YYYY ')}| <span>{moment(item.updatedAt || item.createdAt).format('hh:mm A')} </span>
            </li>
          </ul>
        </Card.Body>
      </Card>
    </div>
  );
}

export default BomTypeGroupCard;
